import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-delivery-signature-preview',
    templateUrl: './delivery-signature-preview.component.html',
    styleUrls: ['./delivery-signature-preview.component.scss'],
})
export class DeliverySignaturePreviewComponent {
    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            signatureImage: string;
        },
    ) {}

    close() {
        this.dialogRef.close();
    }
}
